import { type ReactElement } from 'react';
import FeaturePageLayout from '../../components/features/FeaturePageLayout';

export default function Banking(): ReactElement {
  return (
    <FeaturePageLayout
      badge="Buchhaltung"
      title="Banking-Integration: Alles automatisch verbuchen"
      subtitle="Verbinden Sie Ihre Bankkonten mit Saldify und importieren Sie Transaktionen automatisch. Zahlungseingänge werden erkannt und offenen Rechnungen zugeordnet."
      heroImage="/screenshots/app-banking.webp"
      heroImageAlt="Bankumsätze in Saldify: automatisch abgerufen und Rechnungen zugeordnet"
      features={[
        {
          title: 'Über 4.000 Banken',
          description: 'Verbinden Sie sich mit fast jeder deutschen Bank – Sparkassen, Volksbanken, Direktbanken und mehr.',
        },
        {
          title: 'Automatischer Import',
          description: 'Transaktionen werden täglich automatisch abgerufen. Keine manuelle Eingabe mehr.',
        },
        {
          title: 'Intelligente Zuordnung',
          description: 'Zahlungseingänge werden automatisch offenen Rechnungen zugeordnet.',
        },
        {
          title: 'Kategorisierung',
          description: 'Ausgaben werden automatisch den richtigen Kategorien zugewiesen.',
        },
        {
          title: 'Mehrere Konten',
          description: 'Verwalten Sie beliebig viele Bankkonten in einem Dashboard.',
        },
        {
          title: 'Bankensicherheit',
          description: 'Höchste Sicherheitsstandards (PSD2) und Nur-Lese-Zugriff auf Ihre Konten.',
        },
      ]}
      sections={[
        {
          title: 'Bank verbinden in 2 Minuten',
          description: 'Zum Einrichten wählen Sie Ihre Bank, melden Sie sich mit Ihren Online-Banking-Zugangsdaten an und bestätigen Sie die Verbindung. Saldify hat nur Lesezugriff.',
          bullets: [
            'Sichere Verbindung über PSD2-Schnittstelle',
            'Nur Lesezugriff – keine Überweisungen möglich',
            'Verschlüsselte Datenübertragung',
            'Jederzeit widerrufbar',
          ],
          imageSide: 'right',
        },
        {
          title: 'Transaktionen automatisch verbuchen',
          description: 'Saldify lernt aus Ihren Buchungen und schlägt für wiederkehrende Transaktionen automatisch die richtige Kategorie vor. Mit der Zeit wird die Automatisierung immer besser.',
          bullets: [
            'Lernende Kategorisierung',
            'Regeln für wiederkehrende Buchungen',
            'Split-Buchungen für komplexe Transaktionen',
            'Bulk-Bearbeitung für mehrere Einträge',
          ],
          imageSide: 'left',
        },
        {
          title: 'Offene Posten im Griff',
          description: 'Das Offene-Posten-Dashboard zeigt Ihnen alle unbezahlten Rechnungen und unzugeordneten Transaktionen. So behalten Sie den Überblick über Ihre Liquidität.',
          bullets: [
            'Übersicht aller offenen Forderungen',
            'Automatische Zahlungszuordnung',
            'Teilzahlungen verwalten',
            'Mahnungen bei Zahlungsverzug',
          ],
          imageSide: 'right',
        },
      ]}
      ctaTitle="Verbinden Sie Ihre Bank"
      ctaDescription="Automatisieren Sie Ihre Buchhaltung durch die direkte Bankanbindung."
    />
  );
}
